export default __webpack_public_path__ + "static/media/arrow_left.75dd9c7d.svg";